import { useState } from 'react'

// Condivisione articolo: WhatsApp (link -> preview OG) + Storia Instagram.
//
// Storia Instagram: su iOS/Android il menu nativo mostra "Instagram -> Storie"
// SOLO se si condivide un'IMMAGINE (un file), non un link. Quindi al tocco
// generiamo al volo una grafica-storia 9:16 (copertina + titolo + brand) e la
// condividiamo come file via Web Share API. Su desktop (niente file-share) la
// grafica viene scaricata e il link copiato, cosi' si pubblica a mano.
// `compact` = sole icone per le card della lista blog.

const WA_PATH = 'M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z'
const IG_PATH = 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z'

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.crossOrigin = 'anonymous'
    img.onload = () => resolve(img)
    img.onerror = reject
    img.src = src
  })
}

function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath()
  ctx.moveTo(x + r, y)
  ctx.arcTo(x + w, y, x + w, y + h, r)
  ctx.arcTo(x + w, y + h, x, y + h, r)
  ctx.arcTo(x, y + h, x, y, r)
  ctx.arcTo(x, y, x + w, y, r)
  ctx.closePath()
}

function drawCover(ctx, img, x, y, w, h) {
  const ir = img.width / img.height
  const rr = w / h
  let sx, sy, sw, sh
  if (ir > rr) { sh = img.height; sw = sh * rr; sx = (img.width - sw) / 2; sy = 0 }
  else { sw = img.width; sh = sw / rr; sx = 0; sy = (img.height - sh) / 2 }
  ctx.drawImage(img, sx, sy, sw, sh, x, y, w, h)
}

function wrapText(ctx, text, maxWidth, maxLines) {
  const words = String(text).split(/\s+/)
  const lines = []
  let line = ''
  for (const word of words) {
    const test = line ? line + ' ' + word : word
    if (ctx.measureText(test).width > maxWidth && line) { lines.push(line); line = word }
    else line = test
  }
  if (line) lines.push(line)
  if (lines.length > maxLines) {
    lines.length = maxLines
    lines[maxLines - 1] = lines[maxLines - 1].replace(/[\s.,;:]+$/, '') + '…'
  }
  return lines
}

// Genera la grafica-storia 9:16 (1080x1920) e restituisce un Blob PNG.
async function buildStoryImage({ coverUrl, title, kicker, handle, accent, bg }) {
  const W = 1080, H = 1920
  const canvas = document.createElement('canvas')
  canvas.width = W
  canvas.height = H
  const ctx = canvas.getContext('2d')

  ctx.fillStyle = bg
  ctx.fillRect(0, 0, W, H)
  try { await document.fonts.ready } catch { /* ignore */ }

  const COV = { x: 70, y: 360, w: 940, h: 980, r: 40 }
  let hasCover = false
  if (coverUrl) {
    try {
      const img = await loadImage(coverUrl)
      ctx.save()
      roundRect(ctx, COV.x, COV.y, COV.w, COV.h, COV.r)
      ctx.clip()
      drawCover(ctx, img, COV.x, COV.y, COV.w, COV.h)
      const g = ctx.createLinearGradient(0, COV.y, 0, COV.y + COV.h)
      g.addColorStop(0.5, 'rgba(0,0,0,0)')
      g.addColorStop(1, bg)
      ctx.fillStyle = g
      ctx.fillRect(COV.x, COV.y, COV.w, COV.h)
      ctx.restore()
      ctx.strokeStyle = accent + '66'
      ctx.lineWidth = 3
      roundRect(ctx, COV.x, COV.y, COV.w, COV.h, COV.r)
      ctx.stroke()
      hasCover = true
    } catch { /* niente copertina: si prosegue senza */ }
  }
  if (!hasCover) {
    const g = ctx.createLinearGradient(COV.x, COV.y, COV.x + COV.w, COV.y + COV.h)
    g.addColorStop(0, accent + '33')
    g.addColorStop(1, 'rgba(139,92,246,0.20)')
    ctx.fillStyle = g
    roundRect(ctx, COV.x, COV.y, COV.w, COV.h, COV.r)
    ctx.fill()
  }

  // Kicker in alto
  ctx.fillStyle = accent
  ctx.font = '700 38px system-ui, -apple-system, sans-serif'
  if ('letterSpacing' in ctx) ctx.letterSpacing = '6px'
  ctx.fillText(kicker.toUpperCase(), 70, 200)
  if ('letterSpacing' in ctx) ctx.letterSpacing = '0px'

  // Titolo
  ctx.fillStyle = '#ffffff'
  ctx.font = '800 76px system-ui, -apple-system, sans-serif'
  const lines = wrapText(ctx, title, W - 140, 5)
  let ty = 1520
  for (const l of lines) { ctx.fillText(l, 70, ty); ty += 92 }

  // CTA in basso
  ctx.fillStyle = accent
  ctx.font = '700 42px system-ui, -apple-system, sans-serif'
  ctx.fillText('Leggi su ' + handle + '  →', 70, 1840)

  return await new Promise((resolve) => canvas.toBlob(resolve, 'image/png', 0.92))
}

function downloadBlob(blob, name) {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = name
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(url), 2000)
}

const STORY_BRAND = { kicker: 'Nerd Blog', handle: 'nerdcoach.it', accent: '#34d2ff', bg: '#050510' }

export default function ShareButtons({ title, url, coverUrl, compact = false }) {
  const [state, setState] = useState('idle') // idle | busy | done
  const shareUrl = url || (typeof window !== 'undefined' ? window.location.href : '')
  const waHref = `https://wa.me/?text=${encodeURIComponent(`${title} ${shareUrl}`)}`

  const handleStory = async (e) => {
    if (e) e.stopPropagation()
    if (state === 'busy') return
    setState('busy')
    try {
      const blob = await buildStoryImage({ coverUrl, title, ...STORY_BRAND })
      const file = new File([blob], 'storia-nerdcoach.png', { type: 'image/png' })
      if (typeof navigator !== 'undefined' && navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], text: `${title} ${shareUrl}` })
        setState('idle')
      } else {
        downloadBlob(blob, 'storia-nerdcoach.png')
        try { await navigator.clipboard.writeText(shareUrl) } catch { /* ignore */ }
        setState('done')
        setTimeout(() => setState('idle'), 3500)
      }
    } catch {
      // Fallback estremo: condividi/copia il link
      if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
        try { await navigator.share({ title, text: title, url: shareUrl }) } catch { /* annullato */ }
        setState('idle')
      } else {
        try { await navigator.clipboard.writeText(shareUrl) } catch { /* ignore */ }
        setState('done')
        setTimeout(() => setState('idle'), 3500)
      }
    }
  }

  if (compact) {
    return (
      <div className="flex items-center gap-2">
        <span className="text-nerd-gray/40 text-[10px] font-display uppercase tracking-widest mr-auto">Condividi</span>
        <a
          href={waHref}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
          aria-label="Condividi su WhatsApp"
          className="inline-flex items-center justify-center w-8 h-8 rounded-md border border-nerd-cyan/25 text-nerd-cyan hover:border-nerd-cyan hover:bg-nerd-cyan/10 transition-all"
        >
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor"><path d={WA_PATH} /></svg>
        </a>
        <button
          type="button"
          onClick={handleStory}
          aria-label="Condividi nella storia Instagram"
          title={state === 'done' ? 'Immagine salvata + link copiato' : 'Storia Instagram'}
          className="inline-flex items-center justify-center w-8 h-8 rounded-md border border-nerd-purple/30 text-nerd-purple hover:border-nerd-purple hover:bg-nerd-purple/10 transition-all disabled:opacity-60"
          disabled={state === 'busy'}
        >
          {state === 'busy' ? (
            <svg className="w-4 h-4 animate-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" d="M12 3a9 9 0 1 0 9 9" /></svg>
          ) : state === 'done' ? (
            <svg className="w-4 h-4 text-nerd-cyan" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>
          ) : (
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor"><path d={IG_PATH} /></svg>
          )}
        </button>
      </div>
    )
  }

  return (
    <div className="flex flex-wrap items-center gap-3">
      <span className="text-nerd-gray/60 text-xs font-display uppercase tracking-widest">Condividi la quest</span>
      <a
        href={waHref}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Condividi su WhatsApp"
        className="inline-flex items-center gap-2 px-4 py-2 rounded-lg border border-nerd-cyan/30 bg-nerd-dark/60 text-nerd-white text-sm font-display hover:border-nerd-cyan hover:shadow-[0_0_20px_rgba(0,212,255,0.2)] transition-all"
      >
        <svg className="w-4 h-4 text-nerd-cyan" viewBox="0 0 24 24" fill="currentColor"><path d={WA_PATH} /></svg>
        WhatsApp
      </a>
      <button
        type="button"
        onClick={handleStory}
        aria-label="Condividi nella storia Instagram"
        disabled={state === 'busy'}
        className="inline-flex items-center gap-2 px-4 py-2 rounded-lg border border-nerd-purple/40 bg-nerd-dark/60 text-nerd-white text-sm font-display hover:border-nerd-purple hover:shadow-[0_0_20px_rgba(139,92,246,0.25)] transition-all disabled:opacity-60"
      >
        <svg className="w-4 h-4 text-nerd-purple" viewBox="0 0 24 24" fill="currentColor"><path d={IG_PATH} /></svg>
        {state === 'busy' ? 'Genero la grafica…' : state === 'done' ? 'Immagine salvata + link copiato' : 'Storia Instagram'}
      </button>
    </div>
  )
}
